module.exports = __webpack_public_path__ + "static/media/certn_integration_ss_2.af711c10.jpg";